import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { User } from '@clearroadlab/cam';

import { OdometersService } from '../odometers/odometers.service';
import { ProgramsService } from '../programs/programs.service';
import { VehiclesService } from '../vehicles/vehicles.service';
import { VehicleTripsService } from '../vehicle-trips/vehicle-trips.service';
import { UsersService } from '../users/users.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnDestroy {
  private subscriptions: Subscription[] = [];

  public user: User;
  public userShow = true;
  public companiesCollapse = true;
  isSuperAdmin$: boolean;

  constructor(
    private router: Router,
    public odometersService: OdometersService,
    public programsService: ProgramsService,
    public vehiclesService: VehiclesService,
    public vehicleTripsService: VehicleTripsService,
    public usersService: UsersService
  ) {
    this.subscriptions.push(this.usersService.user$.subscribe(user => this.user = user));
    this.isSuperAdmin$ = this.usersService.isSuperAdmin();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  isCurrentUrl(url: string) {
    return this.router.url === url;
  }

  startsWithUrl(url: string) {
    return this.router.url.indexOf(url) === 0;
  }

  logout() {
    return this.usersService.signOut();
  }

  isClearRoadAdmin() {
    return this.user && this.user.invitationCode === environment.superAdmin.key;
  }
}
